import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import emailjs from 'emailjs-com';

import EmailSent from '../Images/email.png';
import { toast } from 'react-toastify';

const SentEmailForm = () => {

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        const name = e.target.name.value;
        emailjs.sendForm('service_di76kln', 'template_e5n9wdb', form.current, '_fHk8ZM4EScpwnyB0')
            .then((result) => {
                if (result.text === 'OK') {
                    toast.success(`Thank You, ${name}!!.`)
                }
            }, (error) => {
                toast.error(`Message Not Sent! ${name}`)
            });
        e.target.reset();
    };

    return (
        <div className='py-4' id='contact'>
            <div className="grid lg:grid-cols-2 my-5 md:grid-cols-2 grid-cols-1">
                <div
                    data-aos="fade-up"
                    data-aos-offset="300"
                    data-aos-easing="ease-in-sine"
                >
                    <img src={EmailSent} className="w-5/6 mt-2" alt="Email_Sent" />
                </div>
                <div className="card lg:mt-7 bg-base-100   shadow-xl w-5/6 mx-auto"
                    data-aos="fade-down"
                    data-aos-offset="300"
                    data-aos-easing="ease-in-sine"
                >
                    <div className="card-body" >
                        <h2 className='text-3xl text-center pb-4 font-bold text-green-500'>Contact Me</h2>
                        <form ref={form} onSubmit={sendEmail} className='grid grid-cols-1 gap-y-3' >
                            <input type="text" name='name' placeholder="Name" className="input input-bordered w-full  " required />
                            <input type="email" name='email' placeholder="Enter Email" className="input input-bordered w-full " required />
                            <input type="text" name='subject' placeholder="Subject" className="input input-bordered w-full  " required />
                            <textarea style={{ resize: 'none' }} name="message" className="textarea textarea-bordered" placeholder="Enter Message..." required></textarea>
                            <button type='submit' className='btn mt-2 bg-primary border-0 text-white'>Sent Message <FontAwesomeIcon className='ml-2' icon={faEnvelope} /> </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SentEmailForm;


